import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';

function NetworksPage() {
  const [networks, setNetworks] = useState([]);
  const [newNetwork, setNewNetwork] = useState({ cidr: '', description: '', sensorId: '' });
  const [editingNetwork, setEditingNetwork] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteNetworkId, setDeleteNetworkId] = useState(null);
  const { API_BASE_URL} = useAuth();

  useEffect(() => {
    fetchNetworks();
  }, []);

  const fetchNetworks = () => {
    const token = localStorage.getItem('token');
    fetch(API_BASE_URL+'networks', {
      headers: { Authorization: token }, // Token without Bearer prefix
    })
      .then((res) => {
        if (res.status === 401) {
          alert('Session expired. Please log in again.');
          localStorage.removeItem('token');
          window.location.href = '/'; // Redirect to login page
          return [];
        }
        return res.json();
      })
      .then((data) => setNetworks(data))
      .catch((err) => console.error(err));
  };

  const handleAddNetwork = () => {
    const token = localStorage.getItem('token');
    fetch(API_BASE_URL+'networks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token, // Token without Bearer prefix
      },
      body: JSON.stringify(newNetwork),
    })
      .then((res) => {
        if (res.status === 401) {
          alert('Session expired. Please log in again.');
          localStorage.removeItem('token');
          window.location.href = '/'; // Redirect to login page
          return;
        }
        return res.json();
      })
      .then(() => {
        fetchNetworks();
        setNewNetwork({ cidr: '', description: '', sensorId: '' });
        setAddModalOpen(false); // Close the modal after adding
      })
      .catch((err) => console.error(err));
  };

  const handleEditNetwork = (network) => {
    setEditingNetwork(network);
  };

  const handleSaveEditNetwork = () => {
    const token = localStorage.getItem('token');
    fetch(API_BASE_URL+`networks/${editingNetwork.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token, // Token without Bearer prefix
      },
      body: JSON.stringify(editingNetwork),
    })
      .then(() => {
        fetchNetworks();
        setEditingNetwork(null); // Close the modal after saving
      })
      .catch((err) => console.error(err));
  };

  const confirmDelete = (id) => {
    setDeleteNetworkId(id);
    setShowConfirm(true);
  };

  const handleDeleteNetwork = () => {
    const token = localStorage.getItem('token');
    fetch(API_BASE_URL+`networks/${deleteNetworkId}`, {
      method: 'DELETE',
      headers: { Authorization: token },
    })
      .then(() => {
        fetchNetworks();
        setShowConfirm(false);
        setDeleteNetworkId(null);
      })
      .catch((err) => console.error(err));
  };

  const cancelDelete = () => {
    setShowConfirm(false);
    setDeleteNetworkId(null);
  };

  return (
    <div>
      <h2>Networks</h2>
      <button
        className="btn btn-primary mb-3"
        onClick={() => setAddModalOpen(true)}
      >
        Add Network
      </button>

      <table className="table">
        <thead>
          <tr>
            <th>CIDR</th>
            <th>Description</th>
            <th>Sensor ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(networks) &&
            networks.map((network, idx) => (
              <tr key={idx}>
                <td>{network.cidr}</td>
                <td>{network.description}</td>
                <td>{network.sensorId}</td>
                <td>
                  <button
                    className="btn btn-warning me-2"
                    onClick={() => handleEditNetwork(network)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => confirmDelete(network.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {/* Add Network Modal */}
      {addModalOpen && (
        <div
          className="modal show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Network</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAddModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">CIDR</label>
                  <input
                    className="form-control"
                    value={newNetwork.cidr}
                    onChange={(e) =>
                      setNewNetwork({ ...newNetwork, cidr: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <input
                    className="form-control"
                    value={newNetwork.description}
                    onChange={(e) =>
                      setNewNetwork({ ...newNetwork, description: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Sensor ID</label>
                  <input
                    className="form-control"
                    value={newNetwork.sensorId}
                    onChange={(e) =>
                      setNewNetwork({ ...newNetwork, sensorId: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleAddNetwork}>
                  Add Network
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Network Modal */}
      {editingNetwork && (
        <div
          className="modal show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Network</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditingNetwork(null)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">CIDR</label>
                  <input
                    className="form-control"
                    value={editingNetwork.cidr}
                    onChange={(e) =>
                      setEditingNetwork({ ...editingNetwork, cidr: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <input
                    className="form-control"
                    value={editingNetwork.description}
                    onChange={(e) =>
                      setEditingNetwork({ ...editingNetwork, description: e.target.value })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Sensor ID</label>
                  <input
                    className="form-control"
                    value={editingNetwork.sensorId}
                    onChange={(e) =>
                      setEditingNetwork({ ...editingNetwork, sensorId: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={handleSaveEditNetwork}
                >
                  Save Changes
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditingNetwork(null)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {showConfirm && (
        <div
          className="modal show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" onClick={cancelDelete} />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this network?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={cancelDelete}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleDeleteNetwork}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NetworksPage;
